import React, { useState, useEffect, Fragment, useRef } from 'react';
import groupService from '../../../Group/services';
import service from '../service';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import MenuItem from '@material-ui/core/MenuItem';
import { PageHeader } from '../../../../Common';
import Joi from '@hapi/joi';
import { validateProperty, validate } from "../../../Common";
import { CSVLink } from "react-csv";
import TextField from '@material-ui/core/TextField';
import FormHelperText from '@material-ui/core/FormHelperText';
import "react-datepicker/dist/react-datepicker.css";
import { SummeryReportSchema } from "../summeryReportSchema";
import { TableContentWithoutEdit } from '../../../Common/Table/tableContent';
import $ from 'jquery';
import { LoadingSpinerComponent } from '../../../../Common/loader'
import { trackPromise } from 'react-promise-tracker';
import authService from '../../../Common/services';
import tokenService from '../../../../Common/tokenDecoder';
import ReactToPrint from "react-to-print";
import CreatePdf from './createPdf';
import '../../../Common/Table/table.css';
import xlsx from 'json-as-xlsx';

const screenCode = 'DAILYCOLLECTIONSUMMARYREPORT'

export function DailyCollectionSummeryReport(props) {

    const componentRef = useRef();

    const [groups, setGroups] = useState([]);
    const [operationEntity, setOperationEntity] = useState([]);
    const [collectionPoint, setCollectionPoint] = useState([]);
    const [collectionCategory, setCollectionCategory] = useState([]);
    const [isTableHide, setIsTableHide] = useState(true);
    const [searchData, setsearchData] = useState({
        groupID: "0",
        operationEntityID: "0",
        collectionCategoryID: "0",
        toDate: "",
        fromDate: "",
        collectionPointID: "0"
    });


    const [selectedSearchValues, setSelectedSearchValues] = useState({
        group: "0",
        operationEntity: "0",
        collectionCategory: "0",
        toDate: "",
        fromDate: "",
    })

    const pdfRef = React.createRef();
    const [errors, setErrors] = useState({});

    const options = {
        orientation: 'landscape',
        unit: 'in',
        format: [1100, 700],

    };

    const schema = Joi.object(SummeryReportSchema).options({ allowUnknown: true });
    const contentRowNames = ["collectionPointName", "actualAmount", "grossAmount", "netAmount"]
    const csvHeaders = [
        { label: "Collection PointName", value: "collectionPointName" },
        { label: "Actual Amount (Kg)", value: "actualAmount" },
        { label: "Gross Amount (Kg)", value: "grossAmount" },
        { label: "Net Amount (Kg)", value: "netAmount" }
    ];

    const [data, setdata] = useState([]);
    const [totalCollections, setTotalCollections] = useState({
        actualAmount: 0,
        grossAmount: 0,
        netAmount: 0
    });
    const [csvData, setCsvData] = useState([]);

    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isOperationEntityFilterEnabled: false
    });
    const [searchButtonHide, setSearchButtonHide] = useState(false);
    const [buttonHide, setButtonHide] = useState(true);

    useEffect(() => {
        createDataTable();
        trackPromise(
            getPermissions()
        );
    }, [])

    useEffect(() => {
        trackPromise(
            getOperationEntities()
        )
    }, [searchData.groupID])

    useEffect(() => {
        trackPromise(
            getCollectionCategoryForDropDown()
        )
        getCollectionPointsForDropDown();
    }, [searchData.operationEntityID]);

    async function getPermissions() {
        var permissions = await authService.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'DAILYCOLLECTIONSUMMARYREPORT');

        if (isAuthorized === undefined) {
            props.history.push('/unauthorized');
        }
        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');

        var isOperationEntityFilterEnabled = permissions.find(p => p.permissionCode == 'OPERATIONENTITYDROPDOWN');
        setPermissions({
            ...permissionList,

            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isOperationEntityFilterEnabled: isOperationEntityFilterEnabled !== undefined
        });

        var token = tokenService.getUserDetailsFromToken();
        setsearchData({
            ...searchData,
            groupID: token.groupID,
            operationEntityID: token.operationEntityID
        });

        trackPromise(
            getGroupsForDropDown()
        );
    }

    function destroyDataTable() {
        $('#routeCollectionSummaryReport').DataTable().destroy();
    }

    function createDataTable() {
        $('#routeCollectionSummaryReport').DataTable();
    }

    async function getGroupsForDropDown() {
        const groupsList = await groupService.getGroupsForDropdown();
        setGroups(groupsList);
    }

    async function getOperationEntities() {
        const operationEntityList = await service.getOperationEntitiesByGroupForDropDown(searchData.groupID);
        setOperationEntity(operationEntityList);
    }

    async function getCollectionCategoryForDropDown() {
        const collectionCategory = await service.getCollectionCategoryByOperationEntityForDropDown(searchData.operationEntityID);
        setCollectionCategory(collectionCategory);
    }

    async function getCollectionPointsForDropDown() {
        const collectionPoint = await service.getCollectionPointsByOperationentityGroupID(searchData.operationEntityID, searchData.groupID);
        setCollectionPoint(collectionPoint);
    }

    function handleChange(e) {
        e.preventDefault();

        const target = e.target;
        const value = target.value;

        const error = { ...errors };
        const errorMessage = validateProperty(target, SummeryReportSchema);
        errorMessage ? error[target.name] = errorMessage : delete error[target.name];

        setsearchData({
            ...searchData,
            [e.target.name]: value
        })
    }

    async function handleSearch(e) {
        e.preventDefault();

        let actualAmount = 0;
        let grossAmount = 0;
        let netAmount = 0;

        setIsTableHide(true);

        const errorMessages = validate(schema, searchData);
        errorMessages !== null ? setErrors(errorMessages) : setErrors({});
        if (errorMessages) return;

        getSelectedDropdownValuesForReport(searchData);
        let result = await service.getReportData(searchData);

        for (const item of result) {
            actualAmount = actualAmount + item.actualAmount;
            grossAmount = grossAmount + item.grossAmount;
            netAmount = netAmount + item.netAmount;
        }

        const sumValues = [{
            collectionPointName: "Total",
            actualAmount: actualAmount.toFixed(2),
            grossAmount: grossAmount.toFixed(2),
            netAmount: netAmount.toFixed(2)
        }];

        destroyDataTable();
        setdata(result);
        setTotalCollections({
            ...totalCollections,
            actualAmount: actualAmount.toFixed(2),
            grossAmount: grossAmount.toFixed(2),
            netAmount: netAmount.toFixed(2)
        });
        setIsTableHide(false);
        createDataTable();
        setButtonHide(false);
        const comleteData = [...result, ...sumValues];

        setCsvData(comleteData);
    }

    function createFile() {
        var settings = {
            sheetName: 'Daily Collection Summary',
            fileName: 'DailyCollectionSummaryReport',
            writeOptions: {}
        }
        xlsx(csvHeaders, csvData, settings, true)
    }

    function getSelectedDropdownValuesForReport(searchForm) {
        setSelectedSearchValues({
            ...selectedSearchValues,
            group: groups[searchForm.groupID],
            operationEntity: operationEntity[searchForm.operationEntityID],
            collectionCategory: collectionCategory[searchForm.collectionCategoryID],
            toDate: searchForm.toDate,
            fromDate: searchForm.fromDate
        })
    }


    function generateDropDownMenu(data) {
        let items = []
        if (data != null) {
            for (const [key, value] of Object.entries(data)) {
                items.push(<MenuItem key={key} value={key}>{value}</MenuItem>);
            }
        }
        return items
    }

    function hideSearchButton() {

        setSearchButtonHide(true);
    }

    function showSearchButton() {

        setSearchButtonHide(false);
    }
    return (
        <Fragment>
            <LoadingSpinerComponent />
            <div className="row">
                <div className="card">
                    <div ref={pdfRef} className="card-body">
                        <div className="row">
                            <PageHeader
                                title="Route Collection Summary Report"
                                isButtonEnable={false}
                            />
                        </div>
                        <form >
                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <InputLabel shrink id="groupID">Group *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="groupID"
                                        disabled={!permissionList.isGroupFilterEnabled}
                                        name="groupID"
                                        value={searchData.groupID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Group--</MenuItem>
                                        {generateDropDownMenu(groups)}
                                    </Select>
                                    {errors["groupID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["groupID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="operationEntityID">Operation Entity *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="operationEntityID"
                                        disabled={!permissionList.isOperationEntityFilterEnabled}
                                        name="operationEntityID"
                                        value={searchData.operationEntityID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Operation Entity--</MenuItem>
                                        {generateDropDownMenu(operationEntity)}
                                    </Select>
                                    {errors["operationEntityID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["operationEntityID"]}</FormHelperText>}
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionCategoryID">Collection Category *</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionCategoryID"
                                        name="collectionCategoryID"
                                        value={searchData.collectionCategoryID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection Category--</MenuItem>
                                        {generateDropDownMenu(collectionCategory)}
                                    </Select>
                                    {errors["collectionCategoryID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionCategoryID"]}</FormHelperText>}
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <TextField
                                        id="fromDate"
                                        label="From Date *"
                                        name="fromDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                                <div className="col-md pb-1">
                                    <TextField
                                        id="toDate"
                                        label="To Date *"
                                        name="toDate"
                                        type="date"
                                        fullWidth
                                        onChange={(e) => handleChange(e)}
                                        InputLabelProps={{
                                            shrink: true,
                                        }}
                                    />
                                </div>

                                <div className="col-md pb-1">
                                    <InputLabel shrink id="collectionPointID *">Collection point</InputLabel>
                                    <Select
                                        fullWidth
                                        id="collectionPointID"
                                        name="collectionPointID"
                                        value={searchData.collectionPointID}
                                        onChange={(e) => handleChange(e)}>
                                        <MenuItem value="0">--Select Collection point--</MenuItem>
                                        {generateDropDownMenu(collectionPoint)}
                                    </Select>
                                    {errors["collectionPointID"] && <FormHelperText id="errbranchCode" className="text text-danger">{errors["collectionPointID"]}</FormHelperText>}
                                </div>
                            </div>

                            <div className="form-group row">
                                <div className="col-md pb-1">
                                    <input
                                        disabled={validate(schema, searchData)}
                                        type="button"
                                        className="btn btn-primary"
                                        value="Generate"
                                        onClick={e => trackPromise(handleSearch(e))}
                                        hidden={searchButtonHide}
                                    />
                                </div>
                            </div>
                        </form>

                        {isTableHide ? null :
                            <div>
                                <div className="row">
                                    <div className="col-md-12">
                                        <div className="table-responsive row-top-gap">
                                            <table id="routeCollectionSummaryReport" className="display dataTable no-footer">
                                                <thead>
                                                    <tr>
                                                        <th>Collection Point Name</th>
                                                        <th>Actual Amount (Kg)</th>
                                                        <th>Gross Amount (Kg)</th>
                                                        <th>Net Amount (Kg)</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    <TableContentWithoutEdit
                                                        data={data}
                                                        contentRowNames={contentRowNames}
                                                    />
                                                </tbody>
                                                <tfoot>
                                                    <tr>
                                                        <td><h6>Total</h6></td>
                                                        <td><h6>{totalCollections.actualAmount}</h6></td>
                                                        <td><h6>{totalCollections.grossAmount}</h6></td>
                                                        <td><h6>{totalCollections.netAmount}</h6></td>
                                                    </tr>
                                                </tfoot>
                                            </table>
                                        </div>
                                    </div>
                                </div>

                                <div className="pt-2">
                                    <input
                                        type="button"
                                        className="btn btn-primary pull-right ml-2"
                                        value="Excel"
                                        onClick={createFile}
                                    />
                                    <ReactToPrint
                                        documentTitle={"Daily Collection Summary Report"}
                                        trigger={() => <input
                                            type="submit"
                                            className="btn btn-primary pull-right ml-2"
                                            value="PDF"

                                        />}
                                        content={() => componentRef.current}
                                    />
                                </div>
                                <div hidden={true}>
                                    <CreatePdf ref={componentRef} data={data}
                                        rowNames={contentRowNames} searchData={selectedSearchValues} footerData={totalCollections} />

                                </div>
                            </div>
                        }
                    </div>
                </div>
            </div>
        </Fragment >
    );
}



